/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-children-prop */
import React, { FC, useEffect, useState } from 'react';
import {
  Button,
  Container,
  CssBaseline,
  Grid,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../../assets/styles/pages/User';
import Header from '../../../../components/Header';
import ModalConfirmFooter from '../../../../components/Modal/ConfirmFooter';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { api } from '../../../../services';
import { useSignInContext } from '../../../../providers/use-signin';
import FooterMenuMain from '../../../../components/FooterMenuMain';

import { ReactComponent as IconCashBack } from '../../../../assets/images/svg/user/cashback.svg';
import {
  FormatPrice,
  FormatPriceEua,
  FormatPriceInput,
} from '../../../../helpers/utils/Formating';
import ModalInput from '../../../../components/Modal/Input';
import TitlePage from '../../../../components/TitlePage';
import { getStorege } from '../../../../helpers/db_storage';

type CashBackProps = {
  idExtrato: number;
  dsCupom: string;
  dsMovimento: string;
  dtMovimento: string;
  flgDisponivel: number;
  hrMovimento: string;
  idPedido: string;
  tpMovimento: string;
  vlMovimento: string;
  vlSaldo: string;
  flgSoma: string;
};

const Extract: FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const signData = useSignInContext();
  const [notCashBack, setNotCashBack] = useState(false);
  const [openModalNotice, setOpenModalNotice] = useState(false);
  const [openModalGerenrateType, setOpenModalGerenrateType] = useState(false);
  const [openModalGerenrateConfirm, setOpenModalGerenrateConfirm] =
    useState(false);
  const [openModalCashbackPartial, setOpenModalCashbackPartial] =
    useState(false);
  const [msgnModalNotice, setMsgModalNotice] = useState({
    title: 'Atenção',
    messagem: '',
  });
  const [dataCashback, setDataCashback] = useState<CashBackProps[]>([]);
  const [dataStorageCity, setDataStorageCity] = useState<any>('');
  const [vlTotalCashback, setVlTotalCashback] = useState<string>('');
  const [vlTotalGerenrate, setVlTotalGerenrate] = useState<string>('');

  const handleToPage = (url: string, replace = false): void => {
    return navigate(url, { replace });
  };

  const handleOpenModalType = async (): Promise<void> => {
    if (parseFloat(vlTotalGerenrate) <= 0.0) {
      setOpenModalNotice(true);
      setMsgModalNotice({
        title: 'Atenção',
        messagem: 'Saldo insuficiente para gerar o resgate.',
      });
      return;
    }
    setOpenModalGerenrateType(true);
  };

  const listMovimentationCashBack = async (): Promise<void> => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.cashBack({
        nr_operacao: 57,
        idMarketplace: dataStorageCity?.idMarketplace,
        idUsuario: signData.data?.user?.idUsuario,
      });

      if (result.data?.retorno === 'NOK') {
        setMsgModalNotice({
          title: 'Atenção',
          messagem: result.data.mensagem,
        });
        setNotCashBack(true);
        setOpenModalNotice(true);
        return;
      }
      setVlTotalCashback(
        FormatPriceEua(FormatPriceInput(result.data[0].vlSaldo)),
      );
      setDataCashback(result.data);
    } catch (error) {
      toast.error('Não foi possível buscar sua movimentação');
    }
  };

  const handleGenerateRansom = async (vl_total: string): Promise<void> => {
    setOpenModalGerenrateType(false);
    if (parseFloat(vl_total) <= 0.0) {
      setOpenModalNotice(true);
      setMsgModalNotice({
        title: 'Atenção',
        messagem: 'Saldo insuficiente para gerar o resgate.',
      });
      return;
    }

    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.cashBack({
        nr_operacao: 58,
        idMarketplace: dataStorageCity?.idMarketplace,
        idUsuario: signData.data?.user?.idUsuario,
        vlResgate: vl_total,
      });
      if (result.data?.retorno === 'NOK') {
        setMsgModalNotice({
          title: 'Atenção',
          messagem: result.data.mensagem,
        });
        setOpenModalNotice(true);
      }

      setVlTotalGerenrate(vl_total);
      setOpenModalGerenrateConfirm(true);
    } catch (error) {
      toast.error('Não foi possível gerar seu cupom');
    }
  };

  const handleConfirmationGenerateRansom = async (
    vl_total: string,
  ): Promise<void> => {
    setOpenModalGerenrateConfirm(false);

    if (!vl_total) {
      return;
    }
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.cashBack({
        nr_operacao: 59,
        idMarketplace: dataStorageCity?.idMarketplace,
        idUsuario: signData.data?.user?.idUsuario,
        vlResgate: vl_total,
      });

      setMsgModalNotice({
        title: result.data?.retorno === 'NOK' ? 'Atenção' : 'Informação',
        messagem: result.data.mensagem,
      });
      listMovimentationCashBack();
      setOpenModalNotice(true);
    } catch (error) {
      toast.error('Não foi possível gerar seu cupom');
    }
  };

  const handleGeneratePartial = async (vl_partial: string): Promise<void> => {
    setOpenModalGerenrateType(false);

    if (parseFloat(vl_partial) > parseFloat(vlTotalCashback)) {
      setOpenModalNotice(true);
      setMsgModalNotice({
        title: 'Atenção',
        messagem: 'O valor do resgate não pode ser superior ao do saldo.',
      });
      setTimeout(() => setOpenModalCashbackPartial(true), 1);
      return;
    }
    setVlTotalGerenrate(vl_partial);
    handleGenerateRansom(vl_partial);
  };

  const handleOpenModalGeneratePartial = async (): Promise<void> => {
    setOpenModalGerenrateType(false);
    setOpenModalCashbackPartial(true);
  };

  useEffect(() => {
    const dataUserStorage = getStorege('@mais/delivery/user');

    if (!dataUserStorage?.idUsuario) {
      toast.info(
        'Você precisa está logado para acessar o programa de recompensa.',
      );

      handleToPage('/fidelity', true);
    }
  }, []);

  useEffect(() => {
    if (openModalNotice) {
      setTimeout(() => {
        setOpenModalNotice(false);
        setMsgModalNotice({
          title: 'Atenção',
          messagem: '',
        });
        if (notCashBack) {
          setNotCashBack(false);
          handleToPage('/dashboard/user', true);
        }
      }, 5000);
    }
  }, [openModalNotice]);

  useEffect(() => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );
    setDataStorageCity(dataStorage);
  }, []);

  useEffect(() => {
    if (dataStorageCity) {
      listMovimentationCashBack();
    }
  }, [dataStorageCity]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Cashback" />
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <h3>Extrato CashBack</h3>
        {dataCashback.length > 0 && (
          <Grid
            container
            item
            justifyContent="center"
            width="80%"
            marginBottom="130px"
          >
            <TitlePage
              title="Disponível Hoje"
              titleSecondary={dataCashback[0].vlSaldo}
              backgroundColor="#F2F2F2"
              titleColor="#222"
              borderRadius="5px"
              margin="0px"
              textTransform="capitalize"
              fontSize="0.8rem"
              paddingContent="5px 0px"
            />
            {dataCashback.map((item: CashBackProps) => (
              <Grid container item marginTop="10px" key={item.idExtrato}>
                <Grid
                  container
                  item
                  className={classeStyle.gridInfoTextCashback}
                >
                  <Typography fontSize={13}>{item.dsMovimento}</Typography>
                  {item.flgSoma === '1' ? (
                    <Typography fontSize={13} color="#008000">
                      + {item.vlMovimento}
                    </Typography>
                  ) : (
                    <Typography fontSize={13} color="#a51713">
                      - {item.vlMovimento}
                    </Typography>
                  )}
                </Grid>
                <Grid
                  container
                  item
                  className={classeStyle.gridInfoTextCashback}
                >
                  {item.idPedido != null ? (
                    <Typography fontSize={13}>
                      Pedido #{item.idPedido}
                    </Typography>
                  ) : item.dsCupom != null ? (
                    <Grid display="flex">
                      <Grid
                        width={15}
                        height={15}
                        bgcolor={
                          item.flgDisponivel == 1 ? '#008000' : '#a51713'
                        }
                        borderRadius={15}
                        marginRight="5px"
                      />
                      <Grid
                        bgcolor="#D9E0E9"
                        borderRadius={1}
                        padding="0px 5px"
                      >
                        <Typography fontSize={13}>
                          Cupom {item.dsCupom}
                        </Typography>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid display="flex">
                      <Grid borderRadius={1} padding="0px 5px" />
                    </Grid>
                  )}
                  <Typography fontSize={13}>
                    {item.dtMovimento} - {item.hrMovimento}
                  </Typography>
                </Grid>
                <hr className={classeStyle.hr} />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
      <Grid
        container
        item
        xs={12}
        justifyContent="center"
        style={{
          position: 'fixed',
          bottom: 65,
          maxWidth: '680px',
          background: '#fff',
        }}
      >
        <Button
          variant="contained"
          className={classeStyle.btnSubmit}
          onClick={handleOpenModalType}
        >
          <IconCashBack fill="#fff" style={{ marginRight: '5px' }} />
          Gerar Resgate
        </Button>
      </Grid>
      <ModalConfirmFooter
        isOpen={openModalNotice}
        title={msgnModalNotice.title}
        message={msgnModalNotice.messagem}
        btnNamePrimary="Ok"
        btnNameSecondary=""
        btnCancel=""
        handleFn={async () => setOpenModalNotice(false)}
        onClose={() => setOpenModalNotice(false)}
        heightModal="400px"
      />
      <ModalConfirmFooter
        isOpen={openModalGerenrateType}
        title="Atenção"
        message="Você deseja efetuar o resgate total ou parcial do valor?"
        btnNamePrimary="Total"
        btnNameSecondary="Parcial"
        btnCancel="Voltar"
        handleFn={async () => handleGenerateRansom(vlTotalCashback)}
        handleFn2={handleOpenModalGeneratePartial}
        onClose={() => setOpenModalGerenrateType(false)}
        heightModal="530px"
      />
      <ModalInput
        isOpen={openModalCashbackPartial}
        btnNamePrimary="Confirmar"
        handleFn={handleGeneratePartial}
        message="Informe o valor que deseja resgatar"
        title="Atenção!"
        inputType="number"
        placeholder="R$"
        onClose={() => setOpenModalCashbackPartial(false)}
      />
      <ModalConfirmFooter
        isOpen={openModalGerenrateConfirm}
        title="Atenção"
        message={`Você deseja efetuar um resgate gerando um cupom de ${FormatPrice(
          vlTotalGerenrate,
        )} para seu proximo pedido?`}
        btnNamePrimary="Sim"
        btnNameSecondary=""
        btnCancel="Não"
        handleFn={async () =>
          handleConfirmationGenerateRansom(vlTotalGerenrate)
        }
        onClose={() => setOpenModalGerenrateConfirm(false)}
        heightModal="480px"
      />
      <FooterMenuMain children="fidelity" />
    </Container>
  );
};

export default Extract;
